import { Alert, Autocomplete, AutocompleteItem, Button, Chip, Popover, PopoverContent, PopoverTrigger, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, useDisclosure } from "@nextui-org/react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useDispatch, useSelector } from "react-redux"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_ENCRYPT_CODE, ENUM_MAINDASHBOARD_DATAGROUP, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, linksUrl } from "../../constants/enum"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal, calculateTotalByKey, selectFilter } from "../../Utility/utility"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarAlt, faCalendarTimes, faCalendarWeek, faCashRegister, faChartBar, faChartSimple, faDashboard, faDotCircle, faExclamationTriangle, faListCheck, faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { Link, useNavigate } from "react-router-dom"
import { setMainDsbRediKey } from "../../state/outstandingReceivableSlice"
import { isMobile } from "react-device-detect"
import ApexStackColumnChart from "../../components/ApexStackColumnChart"
import { toDate } from "date-fns"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { toast } from "react-toastify"
import { isAction } from "@reduxjs/toolkit"



const TextileMasterDashboard = () => {
    // const FixData = [{ "datagroup": "00 as Yarn Stock", "yy": 2024, "mm": 4, "vou_date": "Apr-24", "amount": 0.00, "nos": 0.0000, "meter": 0.000, "weight": 145363.130 },
    /// { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 4, "vou_date": "Apr-24", "amount": -7214.19, "nos": 0.0000, "meter": 0.000, "weight": 14273.632 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 4, "vou_date": "Apr-24", "amount": 17894968.57, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 4, "vou_date": "Apr-24", "amount": 0.00, "nos": 1666.0000, "meter": 138242.250, "weight": 12312.054 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 4, "vou_date": "Apr-24", "amount": 1219822.91, "nos": 294.0000, "meter": 27319.750, "weight": 606.580 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 4, "vou_date": "Apr-24", "amount": 8052024.45, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 5, "vou_date": "May-24", "amount": 4618307.75, "nos": 0.0000, "meter": 0.000, "weight": 25851.124 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 5, "vou_date": "May-24", "amount": 16391279.21, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 5, "vou_date": "May-24", "amount": 0.00, "nos": 1967.0000, "meter": 181492.450, "weight": 16651.043 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 5, "vou_date": "May-24", "amount": 3449305.66, "nos": 645.0000, "meter": 68445.001, "weight": 2744.810 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 5, "vou_date": "May-24", "amount": 17208329.65, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 6, "vou_date": "Jun-24", "amount": 4078506.64, "nos": 0.0000, "meter": 0.000, "weight": 23972.790 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 6, "vou_date": "Jun-24", "amount": 15129262.32, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 6, "vou_date": "Jun-24", "amount": 0.00, "nos": 2295.0000, "meter": 223169.250, "weight": 22397.028 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 6, "vou_date": "Jun-24", "amount": 4611211.25, "nos": 897.0000, "meter": 91812.750, "weight": 6584.940 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 6, "vou_date": "Jun-24", "amount": 16611734.50, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 7, "vou_date": "Jul-24", "amount": 6535702.87, "nos": 0.0000, "meter": 0.000, "weight": 38070.123 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 7, "vou_date": "Jul-24", "amount": 13775564.95, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 7, "vou_date": "Jul-24", "amount": 0.00, "nos": 2734.0000, "meter": 266422.750, "weight": 27519.131 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 7, "vou_date": "Jul-24", "amount": 7499104.30, "nos": 1333.0000, "meter": 139756.200, "weight": 13525.030 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 7, "vou_date": "Jul-24", "amount": 12371033.75, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 8, "vou_date": "Aug-24", "amount": 6132531.60, "nos": 0.0000, "meter": 0.000, "weight": 32151.875 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 8, "vou_date": "Aug-24", "amount": 22807413.11, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 8, "vou_date": "Aug-24", "amount": 0.00, "nos": 2956.0000, "meter": 288604.260, "weight": 27551.404 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 8, "vou_date": "Aug-24", "amount": 7412163.43, "nos": 1448.0000, "meter": 144789.750, "weight": 9153.060 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 8, "vou_date": "Aug-24", "amount": 8712425.90, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 9, "vou_date": "Sep-24", "amount": 5567270.58, "nos": 0.0000, "meter": 0.000, "weight": 31255.740 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 9, "vou_date": "Sep-24", "amount": 17921140.53, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 9, "vou_date": "Sep-24", "amount": 0.00, "nos": 3192.0000, "meter": 316551.250, "weight": 28342.954 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 9, "vou_date": "Sep-24", "amount": 6612068.89, "nos": 1308.0000, "meter": 130616.750, "weight": 6027.753 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 9, "vou_date": "Sep-24", "amount": 9487417.00, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 10, "vou_date": "Oct-24", "amount": 5141662.43, "nos": 0.0000, "meter": 0.000, "weight": 26714.390 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 10, "vou_date": "Oct-24", "amount": 19851483.93, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 10, "vou_date": "Oct-24", "amount": 0.00, "nos": 2989.0000, "meter": 292420.750, "weight": 28250.676 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 10, "vou_date": "Oct-24", "amount": 6216931.96, "nos": 1181.0000, "meter": 119293.750, "weight": 10613.710 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 10, "vou_date": "Oct-24", "amount": 8822748.32, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "01 Yarn Purchase", "yy": 2024, "mm": 11, "vou_date": "Nov-24", "amount": 3450201.63, "nos": 0.0000, "meter": 0.000, "weight": 21145.904 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 11, "vou_date": "Nov-24", "amount": 15908799.72, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 11, "vou_date": "Nov-24", "amount": 0.00, "nos": 2123.0000, "meter": 205107.750, "weight": 22391.666 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 11, "vou_date": "Nov-24", "amount": 4162325.07, "nos": 857.0000, "meter": 85885.000, "weight": 8829.400 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 11, "vou_date": "Nov-24", "amount": 8201565.50, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "02 Other Purchase\/Expenses", "yy": 2024, "mm": 12, "vou_date": "Dec-24", "amount": 1073394.24, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }, { "datagroup": "11 Production", "yy": 2024, "mm": 12, "vou_date": "Dec-24", "amount": 0.00, "nos": 85.0000, "meter": 8155.500, "weight": 967.140 }, { "datagroup": "21 Gray Sales", "yy": 2024, "mm": 12, "vou_date": "Dec-24", "amount": 141342.50, "nos": 28.0000, "meter": 2766.250, "weight": 0.000 }, { "datagroup": "21 Other Income", "yy": 2024, "mm": 12, "vou_date": "Dec-24", "amount": 384293.65, "nos": 0.0000, "meter": 0.000, "weight": 0.000 }]

    // const FixData=[{"datagroup":"01 Yarn Purchase","yy":2024,"mm":4,"vou_date":"Apr-24","amount":5557027.86,"nos":0.0000,"meter":0.000,"weight":47188.390},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":4,"vou_date":"Apr-24","amount":4869347.45,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":4,"vou_date":"Apr-24","amount":0.00,"nos":5771.0000,"meter":609841.100,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":4,"vou_date":"Apr-24","amount":10522720.76,"nos":2811.0000,"meter":290974.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":5,"vou_date":"May-24","amount":4752488.23,"nos":0.0000,"meter":0.000,"weight":39590.080},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":5,"vou_date":"May-24","amount":5142189.84,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":5,"vou_date":"May-24","amount":0.00,"nos":5639.0000,"meter":597326.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":5,"vou_date":"May-24","amount":11692830.21,"nos":2224.0000,"meter":247729.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":6,"vou_date":"Jun-24","amount":5447486.89,"nos":0.0000,"meter":0.000,"weight":41754.420},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":6,"vou_date":"Jun-24","amount":2626283.86,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":6,"vou_date":"Jun-24","amount":0.00,"nos":4977.0000,"meter":536652.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":6,"vou_date":"Jun-24","amount":11882432.51,"nos":2389.0000,"meter":360984.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":7,"vou_date":"Jul-24","amount":5976684.37,"nos":0.0000,"meter":0.000,"weight":43391.652},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":7,"vou_date":"Jul-24","amount":2748670.72,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":7,"vou_date":"Jul-24","amount":0.00,"nos":5493.0000,"meter":588003.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":7,"vou_date":"Jul-24","amount":13546388.05,"nos":3903.0000,"meter":428658.000,"weight":0.000},{"datagroup":"21 Other Income","yy":2024,"mm":7,"vou_date":"Jul-24","amount":19253.32,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":8,"vou_date":"Aug-24","amount":3685784.45,"nos":0.0000,"meter":0.000,"weight":24531.900},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":8,"vou_date":"Aug-24","amount":4676421.05,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":8,"vou_date":"Aug-24","amount":0.00,"nos":5127.0000,"meter":533776.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":8,"vou_date":"Aug-24","amount":15199198.55,"nos":3700.0000,"meter":425664.600,"weight":0.000},{"datagroup":"21 Other Income","yy":2024,"mm":8,"vou_date":"Aug-24","amount":1055294.70,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":9,"vou_date":"Sep-24","amount":14051044.29,"nos":0.0000,"meter":0.000,"weight":96729.960},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":9,"vou_date":"Sep-24","amount":2484082.01,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":9,"vou_date":"Sep-24","amount":0.00,"nos":5845.0000,"meter":606681.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":9,"vou_date":"Sep-24","amount":14591874.21,"nos":2974.0000,"meter":372245.000,"weight":0.000},{"datagroup":"21 Other Income","yy":2024,"mm":9,"vou_date":"Sep-24","amount":113579.75,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":10,"vou_date":"Oct-24","amount":3694582.19,"nos":0.0000,"meter":0.000,"weight":30720.670},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":10,"vou_date":"Oct-24","amount":4307111.04,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":10,"vou_date":"Oct-24","amount":0.00,"nos":6294.0000,"meter":664590.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":10,"vou_date":"Oct-24","amount":10039959.69,"nos":2904.0000,"meter":309992.000,"weight":0.000},{"datagroup":"21 Other Income","yy":2024,"mm":10,"vou_date":"Oct-24","amount":82794.84,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":11,"vou_date":"Nov-24","amount":7156034.73,"nos":0.0000,"meter":0.000,"weight":57226.138},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":11,"vou_date":"Nov-24","amount":2168127.18,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":11,"vou_date":"Nov-24","amount":0.00,"nos":5501.0000,"meter":585588.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":11,"vou_date":"Nov-24","amount":9115321.07,"nos":2979.0000,"meter":293188.000,"weight":0.000},{"datagroup":"01 Yarn Purchase","yy":2024,"mm":12,"vou_date":"Dec-24","amount":827061.69,"nos":0.0000,"meter":0.000,"weight":5154.240},{"datagroup":"02 Other Purchase\/Expenses","yy":2024,"mm":12,"vou_date":"Dec-24","amount":250003.00,"nos":0.0000,"meter":0.000,"weight":0.000},{"datagroup":"11 Production","yy":2024,"mm":12,"vou_date":"Dec-24","amount":0.00,"nos":2543.0000,"meter":275592.000,"weight":0.000},{"datagroup":"21 Gray Sales","yy":2024,"mm":12,"vou_date":"Dec-24","amount":11616815.00,"nos":1340.0000,"meter":187089.000,"weight":0.000},{"datagroup":"02 Other Purchase\/Expenses","yy":2025,"mm":3,"vou_date":"Mar-25","amount":15687695.27,"nos":0.0000,"meter":0.000,"weight":0.000}]
    const { compCode, yearId, isReload, startDate, endDate } = useSelector((state) => state.company)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [avgYarn, setAvgYarn] = useState(0)
    const [otherExpense, setOtherExpense] = useState(0)
    const [grayProduction, setGrayProduction] = useState(0)
    const [avgWeight, setAvgWeight] = useState(0)
    const [yarnCost, setYarnCost] = useState(0)
    const [totalCost, setTotalCost] = useState(0)
    const [avgSales, setAvgSales] = useState(0)
    const [totalSales, setTotalSales] = useState(0)
    const [difference, setDifference] = useState(0)
    const [selFromDate, setSelFromDate] = useState(startDate ? startDate : null)
    const [selToDate, setSelToDate] = useState(endDate ? endDate : null)
    const [selectedUnit, setSelectedUnit] = useState("")
    //const [yaxisMinVal, setYaxisMinVal] = useState(0)
    const [filterDate, setFilterDate] = useState({
        start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
    })
    const { data: unitMaster = [] } = useFetchWithBody({
        url: apiRoute.report.invoice.getUnit,
        queryKey: "Fetch Unit data",
        inputData: {
            compcode: compCode.join(",")
        }
    })
    const filterTableFn = ({ data, columnName, conditionKey }) => {
        let newData = []
        if (conditionKey) {
            newData = data.filter((ele) => ele.datagroup == conditionKey)
        }
        let Total = 0

        if (newData?.length > 0) {
            Total = calculateTotal({
                data: newData,
                columnName: columnName
            })

        }
        return Total ?? 0

    }

    const { isError, isPending, data: mainData = [], mutate: filterMainData } = usePost({
        url: apiRoute.mainDashboard.fetch,
        queryKey: "Fetch main Dashboard data",
    })

    const { data: salPurData = [], mutate: filterSalePurData } = usePost({
        url: apiRoute.mainDashboard.fetchPurSale,
        queryKey: "Fetch main Dashboard Sale Purchase data",
    })
    const [error, setError] = useState("")
    const funloadMainData = () => {
        let error = ""
        const start = dayjs(filterDate.end)
        const end = dayjs(filterDate.start)
        const months = start.diff(end, 'month');
        const t_year = dayjs(startDate).format('YYYY')
        const minDate = t_year - 2 + "-" + dayjs(startDate).format('MM') + "-" + dayjs(startDate).format('DD')

        if (!dayjs(filterDate.start).isValid || !dayjs(filterDate.end).isValid ||
            filterDate.start == "Invalid date" || filterDate.end == "Invalid Date" ||
            filterDate.start == null || filterDate.end == null) {
            toast.error("Inavlid Start / End Date ", {
                "position": "top-center"
            })

        }
        else {
            if (dayjs(filterDate.start).isValid && dayjs(filterDate.end).isValid) {
                if ((dayjs(filterDate.end).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD")) ||
                    (dayjs(filterDate.start).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD"))) {

                    error += `Start / End Date must not be less than ${dayjs(minDate).format("DD-MM-YYYY")},`

                }
            }
            if (dayjs(filterDate.end).isValid && dayjs(filterDate.start).isValid) {
                if ((dayjs(filterDate.end).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD")) ||
                    (dayjs(filterDate.start).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD"))) {

                    error += `Start / End Date must not be greater than ${dayjs(endDate).format("DD-MM-YYYY")},`

                }
            }
            if (months > 12) error += "Date period must not be greater than 1 year,"

            if (error == "") {
                filterMainData({
                    data: {
                        compcode: compCode.join(","),
                        action: "summary",
                        db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
                        fromdate: filterDate.start,
                        todate: filterDate.end,
                        lac_id: selectedUnit || ''
                    }
                })
                filterSalePurData({
                    data: {
                        compcode: compCode.join(","),
                        db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
                        fromdate: filterDate.start,
                        todate: filterDate.end,
                        lac_id: selectedUnit || ''
                    }
                })
                filterSummary({
                    data: {
                        compcode: compCode.join(","),
                        fromdate: filterDate.start,
                        todate: filterDate.end,
                        lacid: selectedUnit || ''
                    }
                })

            }
            else {
                const messages = error.split(',');
                toast.error(
                    <div>
                        {messages.map((msg, idx) => msg != "" ? (

                            <div key={idx} className="p-1">
                                <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} ></FontAwesomeIcon>
                                {msg.trim()}</div> // Trim to remove extra spaces
                        ) : "")}
                    </div>,
                    {
                        position: "top-center",
                        icon: false,
                        style: { whiteSpace: 'pre-line', width: '400px', fontSize: "0.8rem", color: "#da3333ff" }, // Optional here, mostly needed if using \n
                    }
                );
            }
        }
    }
    useEffect(() => {
        funloadMainData()
    }, [])
    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modeSetting.getModSetting,
        queryKey: "fetchModSetting",
        inputData: {
            mod_name: ENUM_MOD_NAME.CostingDashboard
        }
    })

    //console.log(modSetting)
    const { data: summaryData = [], mutate: filterSummary } = usePost({
        url: apiRoute.mainDashboard.fetchSummary,
        queryKey: "Fetch summary Dashboard data",
        // inputData: {
        //     compcode: compCode.join(","),
        // }

    })


    const chartSerName = {
        "avgYarn": "avgYarn",
        "othExp": "othExp",
        "grayProd": "grayProd",
        "avgWeight": "avgWeight",
        "yarnCost": "yarnCost",
        "totalCost": "totalCost",
        "totalSale": "totalSale",
        "avgSale": "avgSale",
        "difference": "difference",
        "pNlSummary": "pNlSummary",
        "pNlAmount": "pNlAmount"


    }

    const chartCaptionName = [{
        avgYarn: "Avg. Yarn",
        othExp: "Oth. Exp",
        grayProd: "Gray Prod.",
        avgWeight: "Avg. Weight",
        yarnCost: "Yarn Cost",
        totalCost: "Total Cost",
        totalSale: "Total Sale",
        avgSale: "Avg. Sale",
        difference: "Difference"
    }]



    const funCalculateCost = (data) => {
        let tempValue = 0;
        let amountColumn = "amount"
        if (modSetting && modSetting?.length > 0) {
            if (getModMandatory(ENUM_MOD_PARAMETER.CostingDashboard.CalcWithGst, modSetting)) {
                amountColumn = "gst_amount"
            }
        }

        const total_Open_Weight_Yn = filterTableFn({ data: data, columnName: "weight", conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._00_OpeningStock })
        const total_Open_Amount_Yn = filterTableFn({ data: data, columnName: amountColumn, conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._00_OpeningStock })
        const total_Weight_YP = filterTableFn({ data: data, columnName: "weight", conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._01_YarnPurchase })
        const total_Amount_YP = filterTableFn({ data: data, columnName: amountColumn, conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._01_YarnPurchase })
        //avgyarn
        tempValue = Math.round((parseFloat(total_Amount_YP ?? 0) + parseFloat(total_Open_Amount_Yn ?? 0)) /
            (parseFloat(total_Weight_YP ?? 0) + parseFloat(total_Open_Weight_Yn)))
        const t_AvgYarn = Number.isNaN(tempValue) || !Number.isFinite(tempValue) || tempValue <= 0 ? 0 : Math.round(tempValue).toFixed(2)

        //otheExp
        const total_Amount_OEXP = filterTableFn({ data: data, columnName: amountColumn, conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._02_OtherExpense })
        const t_OtherExp = (parseFloat(total_Amount_OEXP) / 100000).toFixed(2)

        //otheGrayProd
        const total_Meter_GRP = filterTableFn({ data: data, columnName: "meter", conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._11_Production })
        const t_GrapPrd = (parseFloat(total_Meter_GRP) / 100000).toFixed(2)

        //avgWeight
        const total_Weight_GRP = filterTableFn({ data: data, columnName: "weight", conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._11_Production })
        tempValue = (parseFloat(total_Weight_GRP ?? 0) / parseFloat(total_Meter_GRP ?? 0))
        const t_AvgWeight = Number.isNaN(tempValue) || !Number.isFinite(tempValue) || tempValue <= 0 ? 0 : tempValue.toFixed(3)

        //yarncost
        const t_YarnCost = (parseFloat(t_AvgYarn) * parseFloat(t_AvgWeight)).toFixed(2)

        //total cost

        tempValue = parseFloat(t_YarnCost) + Math.round((parseFloat(total_Amount_OEXP ?? 0) / parseFloat(total_Meter_GRP ?? 0)))
        const t_TotalCost = Number.isNaN(tempValue) || !Number.isFinite(tempValue) || tempValue <= 0 ? 0 : tempValue.toFixed(2)


        //avgsale
        const total_Meter_GRS = filterTableFn({ data: data, columnName: "meter", conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._21_GraySale })
        const total_amount_GRS = filterTableFn({ data: data, columnName: amountColumn, conditionKey: ENUM_MAINDASHBOARD_DATAGROUP._21_GraySale })
        tempValue = (parseFloat(total_amount_GRS ?? 0) / parseFloat(total_Meter_GRS ?? 0))
        const t_AvgSales = Number.isNaN(tempValue) || !Number.isFinite(tempValue) || tempValue <= 0 ? 0 : tempValue.toFixed(2)

        //totalSale
        const t_TotalSale = (parseFloat(total_Meter_GRS) / 100000).toFixed(2)

        tempValue = parseFloat(t_AvgSales) - parseFloat(t_TotalCost)
        const t_diffrence = Number.isNaN(tempValue) || !Number.isFinite(tempValue) ? 0 : tempValue.toFixed(2)



        //PNLchart data
        tempValue = parseFloat(t_AvgSales ?? 0) - parseFloat(t_TotalCost ?? 0)
        const t_PnlSummary = Number.isNaN(tempValue) || !Number.isFinite(tempValue) ? 0 : parseFloat(tempValue.toFixed(2))

        tempValue = parseFloat(t_PnlSummary ?? 0) * parseFloat(total_Meter_GRS ?? 0)
        const t_PnlAmount = Number.isNaN(tempValue) || !Number.isFinite(tempValue) ? 0 : parseFloat(Math.round(tempValue))

        return {
            [chartSerName.avgYarn]: t_AvgYarn, [chartSerName.othExp]: t_OtherExp, [chartSerName.grayProd]: t_GrapPrd,
            [chartSerName.avgWeight]: t_AvgWeight, [chartSerName.yarnCost]: t_YarnCost,
            [chartSerName.totalCost]: t_TotalCost, [chartSerName.totalSale]: t_TotalSale,
            [chartSerName.avgSale]: t_AvgSales, [chartSerName.difference]: t_diffrence,
            [chartSerName.pNlSummary]: t_PnlSummary, [chartSerName.pNlAmount]: t_PnlAmount
        }
    }

    const funGetChartData = (data, isPNlData) => {
        let chartData = []
        let chartFrmtData = []

        if (data && data?.length > 0) {
            const distinctMonth = [
                ...new Map(data.map(item => [item.vou_date, item])).values()
            ].map(item => item.vou_date);

            if (distinctMonth?.length > 0) {
                for (let i = 0; i < distinctMonth.length; i++) {
                    const filter_data = data.filter((ele) => ele.vou_date == distinctMonth[i])
                    const result_data = funCalculateCost(filter_data)
                    chartData = [...chartData, { ...result_data, month: distinctMonth[i] }]

                }
            }
            if (isPNlData) {
                let formatData = chartData.map((ele) => {
                    return { x: ele.month, y: Math.abs(ele.pNlSummary), fillColor: ele.pNlSummary < 0 ? '#f43f5e' : '#2fa133', amt: ele.pNlAmount }
                })
                chartFrmtData = [{ name: 'P&L/MTR', data: formatData }]

            }
            else {
                if (chartData && chartData.length > 0) {
                    Object.keys(chartSerName).map((item) => {
                        const data = chartData.map(ele => Number(ele[item]))
                        const key = chartCaptionName.map(ele => ele[item])
                        if (item != chartSerName.pNlSummary && item != chartSerName.pNlAmount)
                            chartFrmtData = [...chartFrmtData, { name: key, data: data }]
                    })

                }
            }

        }

        return chartFrmtData
    }

    let dataList = useMemo(() => {
        return funGetChartData(mainData, false)
    }, [mainData])

    const PNLdataList = useMemo(() => {
        return funGetChartData(mainData, true)
    }, [mainData])

    let xAxisList = useMemo(() => {
        return [
            ...new Map(mainData.map(item => [item.vou_date, item])).values()
        ].map(item => item.vou_date);
    }, [mainData])


    useEffect(() => {
        const result = funCalculateCost(mainData)
        setAvgYarn(result[chartSerName.avgYarn])
        setOtherExpense(result[chartSerName.othExp])
        setGrayProduction(result[chartSerName.grayProd])
        setAvgWeight(result[chartSerName.avgWeight])
        setYarnCost(result[chartSerName.yarnCost])
        setTotalCost(result[chartSerName.totalCost])
        setAvgSales(result[chartSerName.avgSale])
        setTotalSales(result[chartSerName.totalSale])
        setDifference(result[chartSerName.difference])

    }, [mainData])

    const handleRediDshbrdClick = (key) => {
        dispatch(setMainDsbRediKey(key))
        navigate(linksUrl.dashboard.tradingDashboard + "/" + key)
    }

    useEffect(() => {
        dispatch(setMainDsbRediKey(""))
    }, [])

    useEffect(() => {
        funloadMainData()
    }, [selectedUnit])

    const handleBtnClick = (e) => {
        e.preventDefault();
        funloadMainData()

    }

    const handleReset = () => {
        setFilterDate({
            start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
            end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null
        })
        filterMainData({
            data: {
                compcode: compCode.join(","),
                action: "summary",
                db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
                fromdate: dayjs(startDate).format("YYYY-MM-DD"),
                todate: dayjs(endDate).format("YYYY-MM-DD"),
                lac_id: selectedUnit || ''
            }
        })
        filterSalePurData({
            data: {
                compcode: compCode.join(","),
                db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
                fromdate: dayjs(startDate).format("YYYY-MM-DD"),
                todate: dayjs(endDate).format("YYYY-MM-DD"),
                lac_id: selectedUnit || ''
            }
        })
    }

    //  const [isOpen, setIsOpen] = useState(false);
    // const handleDateChange = (newValue, name) => {

    //     setFilterDate((prev) => {
    //         return {
    //             ...prev, [name]: newValue != '' && newValue != 'Invalid Date' ?
    //                 dayjs(newValue).format("YYYY-MM-DD") : null,
    //         }
    //     })
    // }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterDate(prev => ({
            ...prev,
            [name]: value
        }));
    };
    console.log(selectedUnit)

    if (isError) {
        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }

    return (
        <div>
            <MainContainer pageName="Financial & Costing Status">
                <div className="flex justify-end mb-2 flex-wrap items-center gap-2">
                    <Autocomplete
                        size="sm"
                        label={""}
                        color="danger"
                        eventResizeFeature={true}
                        selectionMode="single"
                        showScrollIndicators={true}
                        placeholder={"--SELECT UNIT--"}
                        className="w-60 font-semibold text-sm"
                        classNames={{ "label": "font-semibold" }}
                        labelPlacement="outside"
                        isClearable={true}
                        variant="flat"
                        isVirtualized
                        defaultItems={
                            unitMaster || []
                        }
                        onSelectionChange={setSelectedUnit}
                        selectedKey={selectedUnit}
                    >
                        {(list) => (
                            <AutocompleteItem

                                key={list.Party_Id}
                            >
                                {list.Party_Name}
                            </AutocompleteItem>
                        )}
                    </Autocomplete>
                    <div className="flex gap-2">
                        <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > From : {dayjs(filterDate.start).format("DD-MMM-YYYY")}</Chip>
                        <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > To : {dayjs(filterDate.end).format("DD-MMM-YYYY")}</Chip>
                    </div>                    {/* date */}

                    <Popover placement="bottom" variant="bordered"
                        isDismissable={false}
                        shouldCloseOnBlur={false}
                        shouldBlockScroll={true}
                        shouldCloseOnScroll={false}
                        showArrow={true}>
                        <PopoverTrigger>
                            <Button size="sm"
                                className="bg-sky-200  text-md border-2 border-sky-300 text-sky-600 px-1" isIconOnly={true}   >
                                <FontAwesomeIcon className="text-xl" icon={faCalendarAlt}></FontAwesomeIcon>
                            </Button>
                            {/* <Button size="sm"
                                className="bg-sky-600 h-7 text-white" variant="shadow" color="warning"  >Change Date</Button> */}
                        </PopoverTrigger>
                        <PopoverContent className="z-[1000]">
                            <div
                                onMouseDown={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                            >
                                <form onSubmit={handleBtnClick} >
                                    <div className={`${isMobile ? 'flex-wrap justify-center' : ''} flex gap-2 p-4`}>
                                        <div className={`flex  gap-2 `}>

                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    name="start"
                                                    value={filterDate.start}
                                                    onChange={handleChange}
                                                    required
                                                    className="block w-full p-1 text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                                                />

                                            </div>
                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    name="end"
                                                    value={filterDate.end}
                                                    onChange={handleChange}
                                                    required
                                                    className="block w-full p-1  text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                                                />

                                            </div>

                                            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label={"Start Date"}
                                                    views={["day", "month", "year"]}
                                                    format="DD/MM/YYYY"
                                                    disableCloseOnSelect
                                                    value={
                                                        filterDate.start
                                                            ? dayjs(filterDate.start)
                                                            : filterDate.start
                                                    }

                                                    onChange={(newValue) => handleDateChange(newValue, "start")}
                                                    sx={{ width: "145px" }}
                                                    slotProps={{
                                                        textField: {
                                                            required: true,
                                                            size: "small",
                                                            sx: {
                                                                zIndex: 9999,
                                                                fontSize: "1rem",          // smaller font
                                                                "& .MuiInputBase-root": {
                                                                    padding: "4px 8px",         // reduce height
                                                                    fontSize: "0.80rem",

                                                                },
                                                                "& input": {
                                                                    padding: "4px 0",           // tweak input spacing
                                                                },
                                                                "& label": {
                                                                    fontSize: "1rem",
                                                                    fontWeight: "300",
                                                                    color: "black"       // smaller label
                                                                },
                                                            }
                                                        },
                                                        popper: {
                                                            modifiers: [
                                                                {
                                                                    name: 'offset',
                                                                    options: {
                                                                        offset: [0, 8],
                                                                    },
                                                                },
                                                            ],
                                                            disablePortal: true, // ⬅️ This renders popup inside parent
                                                        },
                                                    }}
                                                />
                                                <DatePicker
                                                    label={"End Date"}
                                                    views={["day", "month", "year"]}
                                                    format="DD/MM/YYYY"
                                                    disableCloseOnSelect
                                                    value={
                                                        filterDate.end ? dayjs(filterDate.end) : filterDate.end
                                                    }
                                                    onChange={(newValue) => handleDateChange(newValue, "end")}
                                                  
                                                    maxDate={dayjs(endDate)}
                                                    slotProps={{

                                                        textField: {
                                                            required: true,
                                                            size: "small",
                                                            //helperText:!dayjs(filterDate.end).isValid?"invalid Date":"",
                                                            sx: {
                                                                zIndex: 9999,
                                                                // fontSize: "1rem", 
                                                                //          // smaller font
                                                                "& .MuiInputBase-root": {
                                                                    padding: "4px 8px",         // reduce height
                                                                    fontSize: "0.80rem",

                                                                },
                                                                "& input": {
                                                                    padding: "4px 0",           // tweak input spacing
                                                                },
                                                                "& label": {
                                                                    fontSize: "1rem",
                                                                    fontWeight: "300",
                                                                    color: "black"       // smaller label
                                                                },
                                                            }
                                                        },
                                                        popper: {
                                                            modifiers: [
                                                                {
                                                                    name: 'offset',
                                                                    options: {
                                                                        offset: [0, 8],
                                                                    },
                                                                },
                                                            ],
                                                            disablePortal: true, // ⬅️ This renders popup inside parent
                                                        },
                                                    }}
                                                    sx={{ width: "145px" }}
                                                />
                                            </LocalizationProvider> */}
                                        </div>
                                        <div className={`flex  gap-2 `}>
                                            <Button size="sm" variant="shadow" className="bg-blue-700 h-7 text-white" type="submit" >Apply</Button>
                                            <Button size="sm" color="danger" variant="shadow" className=" h-7 text-white" onPress={handleReset} >Reset</Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </PopoverContent>
                    </Popover>
                </div>
                <div className="bg-gray-0">
                    <div className={`  ${isMobile ? "" : ""}`}>
                        <div className=" custm-flex-col flex w-full  gap-1 lg:justify-evenly flex-wrap mx-auto text-center md:text-sm sm:text-xs">

                            <div className={`  ${isMobile ? "" : ""} cutm-w-32 box-content h-15 
                                              p-2 border-2 border-amber-200  shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                             bg-gradient-to-br from-slate-50 to-yellow-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{avgYarn} Rs.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700"> Avg.Yarn</div>


                            </div>

                            <div className={` ${isMobile ? "" : ""} cutm-w-32 box-content h-15 
                                            p-2 border-2 border-cyan-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                             bg-gradient-to-br from-slate-50 to-cyan-100  tracking-wider`} s>
                                <div className="h-10 overflow-hidden">
                                    <h4>{otherExpense} L.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700"> Oth.Exp</div>
                            </div>

                            <div className={`  ${isMobile ? "" : ""} cutm-w-32 box-content h-15
                                                 p-2 border-2 border-rose-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                                bg-gradient-to-br from-slate-50 to-rose-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{grayProduction} L.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700">Gray Prod.</div>
                            </div>

                            <div className={` ${isMobile ? "" : ""} cutm-w-32 box-content h-15 
                                             p-2  border-2 border-emerald-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                                bg-gradient-to-br from-slate-50 to-emerald-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{avgWeight} Kg.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700">Avg.Weight/
                                    <span className="small-font" >MTR.</span></div>
                            </div>

                            <div className={` ${isMobile ? "" : ""} cutm-w-32 box-content h-15
                                         p-2 border-2 border-purple-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                         bg-gradient-to-br from-slate-50 to-purple-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{yarnCost} Rs.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700">Yarn Cost/<span className="small-font" >MTR.</span></div>
                            </div>

                            <div className={` ${isMobile ? "" : ""} cutm-w-32 box-content h-15    
                                             p-2 border-2 border-lime-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                             bg-gradient-to-br from-slate-50 to-lime-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{totalCost} Rs.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700"> Total Cost/<span className="small-font" >MTR.</span></div>

                            </div>
                            <div className={`  ${isMobile ? "" : ""} cutm-w-32 box-content h-15  
                                   p-2 border-2 border-blue-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                    bg-gradient-to-br from-slate-50 to-blue-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{totalSales} L.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700"> Total Sales</div>
                            </div>
                            <div className={`  ${isMobile ? "" : ""} cutm-w-32 box-content h-15  
                                   p-2 border-2 border-orange-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                    bg-gradient-to-br from-slate-50 to-orange-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{avgSales} Rs.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700"> Avg.Sales</div>
                            </div>
                            <div className={`  ${isMobile ? "" : ""} cutm-w-32 box-content h-15  
                                   p-2 border-2 border-green-200 shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]
                                    bg-gradient-to-br from-slate-50 to-green-200  tracking-wider`}>
                                <div className="h-10 overflow-hidden">
                                    <h4>{difference} Rs.</h4>
                                </div>
                                <div className="text-xs font-bold text-gray-700"> Difference</div>
                            </div>

                        </div>
                    </div>
                    <div className="flex w-full border-0 border-gray-700 mt-10 flex-wrap mx-auto  md:text-sm sm:text-xs item-center  justify-evenly">
                        <div className={` ${isMobile ? "w-full order-last" : "w-1/3 order-first"}   custm-w-40  align-top border-0 border-gray-100 mx-auto`} >
                            <div className=" mx-auto mb-2  shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]">
                                <div className="box-border  w-full  border-1 border-emerald-200
                                       
                            ">

                                    <div className="font-semibold border-b-2 p-2 bg-gradient-to-br from-white to-sky-50 tracking-wider "   >
                                        <FontAwesomeIcon icon={faChartSimple} className="text-rose-400 mr-1 " /> Purchase
                                    </div>
                                    <div className="overflow-auto">
                                        {salPurData && salPurData?.purchaseData && salPurData?.purchaseData.length > 0 ?
                                            (
                                                <Table removeWrapper isHeaderSticky radius="none" onRowAction={() => handleRediDshbrdClick(ENUM_ENCRYPT_CODE.purchase)}
                                                    classNames={{
                                                        th: [" text-rose-400", "bg-gradient-to-br from-white to-sky-50"],
                                                        tr: ["hover:bg-gray-50", "hover:text-lime-500",
                                                            "border-b-1 ", "border-emerald-200", "font-semibold", "cursor-pointer"],
                                                        td: ["text-xs"]
                                                    }}
                                                >
                                                    <TableHeader>
                                                        <TableColumn>Jobwork</TableColumn>
                                                        <TableColumn className="text-center">Net.Amt</TableColumn>
                                                        <TableColumn className="text-center">Qty</TableColumn>
                                                        <TableColumn className="text-center">Net.Rate</TableColumn>
                                                    </TableHeader>
                                                    <TableBody>
                                                        {
                                                            salPurData?.purchaseData.map((ele, i) => {
                                                                return (
                                                                    <TableRow key={i} >
                                                                        <TableCell className="text-xs1">
                                                                            {ele.jobwork}
                                                                        </TableCell>
                                                                        <TableCell className="text-xs1 text-right">
                                                                            {ele.amount}
                                                                        </TableCell>

                                                                        <TableCell className="text-xs1 text-right">
                                                                            {ele.qty}
                                                                        </TableCell>
                                                                        <TableCell className="text-x1 text-right" >
                                                                            {(ele.amount / ele.qty).toFixed(2)}
                                                                        </TableCell>

                                                                    </TableRow>
                                                                )
                                                            })
                                                        }
                                                    </TableBody>
                                                </Table>
                                            ) : (<div className="text-gray-400  p-7 text-center" >Loading......</div>)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className=" mx-auto m-2  shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]">
                                <div className="box-border  w-full border-1 border-orange-200
                                         
                            ">
                                    <div className="font-semibold  border-b-2 p-2 bg-gradient-to-br from-white to-sky-50 tracking-wider "   >
                                        <FontAwesomeIcon icon={faPenToSquare} className="text-rose-400 mr-1" /> Sales
                                    </div>

                                    <div className="overflow-x-auto">
                                        {salPurData && salPurData?.saleData && salPurData?.saleData.length > 0 ?
                                            (
                                                <Table removeWrapper isHeaderSticky radius="none" onRowAction={() => handleRediDshbrdClick(ENUM_ENCRYPT_CODE.sale)}
                                                    classNames={{
                                                        th: [" text-rose-400", "bg-gradient-to-br from-white to-sky-50"],
                                                        tr: ["hover:bg-gray-50", "hover:text-lime-500",
                                                            "border-b-1 ", "border-orange-200", "small-text", "font-semibold", "cursor-pointer"],
                                                        td: ["text-xs"]
                                                    }}
                                                >
                                                    <TableHeader>
                                                        <TableColumn >Jobwork</TableColumn>
                                                        <TableColumn className="text-center">Net.Amt</TableColumn>
                                                        <TableColumn className="text-center">Qty</TableColumn>
                                                        <TableColumn className="text-center">Net.Rate</TableColumn>
                                                    </TableHeader>
                                                    <TableBody>
                                                        {
                                                            salPurData?.saleData.map((ele, i) => {
                                                                return (
                                                                    <TableRow key={i} >
                                                                        <TableCell className="small-text1">
                                                                            {ele.jobwork}
                                                                        </TableCell>
                                                                        <TableCell className="small-text1 text-right">
                                                                            {ele.amount}
                                                                        </TableCell>

                                                                        <TableCell className="small-text1 text-right">
                                                                            {ele.qty}
                                                                        </TableCell>
                                                                        <TableCell className="small-text1 text-right" >
                                                                            {(ele.amount / ele.qty).toFixed(2)}
                                                                        </TableCell>

                                                                    </TableRow>
                                                                )
                                                            })
                                                        }
                                                    </TableBody>
                                                </Table>
                                            ) : (<div className="text-gray-400  p-7 text-center" >Loading......</div>)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className=" mx-auto m-2  shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]">
                                <div className="box-border  w-full  border-1 border-purple-200">
                                    <div className="font-semibold  border-b-2 p-2 bg-gradient-to-br from-white to-sky-50 tracking-wider">
                                        <FontAwesomeIcon icon={faListCheck} className="text-rose-400" /> Total Outstanding
                                    </div>
                                    <div className="">
                                        {
                                            summaryData && summaryData?.oustandingData && summaryData?.oustandingData.length > 0 ?
                                                (
                                                    <Table hideHeader removeWrapper
                                                        classNames={{
                                                            tr: ["hover:bg-lime-50", "hover:text-rose-500",
                                                                "border-b-1 ", "border-amber-100", "text-xs", "font-semibold", "cursor-pointer"],
                                                        }}
                                                    >

                                                        <TableHeader>
                                                            <TableColumn></TableColumn>
                                                            <TableColumn></TableColumn>
                                                        </TableHeader>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell>
                                                                    <Link to={linksUrl.dashboard.tradingDashboard + "/" + ENUM_ENCRYPT_CODE.payable}>  Payable</Link>
                                                                </TableCell>
                                                                <TableCell className="text-right">
                                                                    <Link to={linksUrl.dashboard.tradingDashboard + "/" + ENUM_ENCRYPT_CODE.payable}>   {summaryData?.oustandingData[0]?.Payable}</Link>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>
                                                                    <div onClick={() => handleRediDshbrdClick(ENUM_ENCRYPT_CODE.receivable)} >Receivable</div>
                                                                </TableCell>
                                                                <TableCell className="text-right">
                                                                    <div onClick={() => handleRediDshbrdClick(ENUM_ENCRYPT_CODE.receivable)} >  {summaryData?.oustandingData[0]?.Receivable}</div>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell>
                                                                    <div onClick={() => handleRediDshbrdClick(ENUM_ENCRYPT_CODE.difference)} > Difference</div>
                                                                </TableCell>
                                                                <TableCell className="text-right">
                                                                    <div onClick={() => handleRediDshbrdClick(ENUM_ENCRYPT_CODE.difference)} > {summaryData?.oustandingData[0]?.Difference}</div>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                ) : (<div className="text-gray-400  p-7 text-center" >Loading......</div>)
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className=" mx-auto m-2  shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]">
                                <div className="box-border  w-full  border-1 border-cyan-200">
                                    <div className="font-semibold  border-b-2 p-2 bg-gradient-to-br from-white to-sky-50 tracking-wider "   > <FontAwesomeIcon icon={faCashRegister} className="text-rose-400" /> Bank & Cash Balances</div>
                                    <div className={` h-64   ${summaryData && summaryData?.cashNBankData && summaryData?.cashNBankData.length > 6 ? "overflow-y-scroll" : ""}`}>
                                        {summaryData && summaryData?.cashNBankData && summaryData?.cashNBankData.length > 0 ?
                                            (
                                                <Table hideHeader removeWrapper
                                                    classNames={{
                                                        tr: ["hover:bg-gray-50", "hover:text-lime-500",
                                                            "border-b-1 ", "border-sky-200", "small-text", "font-semibold", "cursor-pointer"],
                                                    }}
                                                >
                                                    <TableHeader>
                                                        <TableColumn></TableColumn>
                                                        <TableColumn></TableColumn>
                                                        <TableColumn></TableColumn>
                                                    </TableHeader>
                                                    <TableBody>
                                                        {
                                                            summaryData?.cashNBankData.map((ele, i) => {
                                                                return (
                                                                    <TableRow key={i} className={`${ele.balance < 0 ? 'text-rose-500' : ""}`}>
                                                                        <TableCell className="small-text">
                                                                            {ele.ac_desc}
                                                                        </TableCell>
                                                                        <TableCell className="text-right" >
                                                                            {ele.balance}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {ele.bal_type}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        }
                                                    </TableBody>
                                                </Table>
                                            ) : (<div className="text-gray-400  p-7 text-center" >Loading......</div>)
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${isMobile ? "w-full order-first" : "w-2/3 order-last"}   custm-w-60  align-top border-0 border-gray-100 mx-auto  `} >
                            <div className=" mx-auto mb-5">
                                <div className={` ${isMobile ? "ml-0" : "ml-5"} border-1 border-purple-100 h-auto  shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]`}>
                                    <div className=" font-semibold flex text-md p-5 text-sky-700 align-top items-center
                                          tracking-wider
                            ">
                                        <FontAwesomeIcon icon={faChartBar} className=" mr-5 text-md border-0 border-sky-500 text-rose-500" />
                                        <div> Monthly Cost Summary</div>
                                    </div>
                                    {
                                        mainData && mainData?.length > 0 ?
                                            <ApexStackColumnChart xAxisList={xAxisList} dataList={dataList} isPNL={false} minValue={0} type={"bar"} width={"100%"} ></ApexStackColumnChart>
                                            : (<div className="text-gray-400  p-7 text-center" >Loading......</div>)
                                    }
                                </div>
                            </div>
                            <div className=" mx-auto mb-5">
                                <div className={`  ${isMobile ? "ml-0" : "ml-5"} border-1 border-purple-100 h-auto  shadow-[-1px_6px_12px_3px_rgba(0,_0,_0,_0.1)]`}>
                                    <div className=" font-semibold flex text-md p-5 text-sky-700 align-top items-center
                                          tracking-wider
                            ">
                                        <FontAwesomeIcon icon={faChartBar} className=" mr-5 text-md border-0 border-sky-500 text-rose-500" />
                                        <div> Monthly P & L Summary</div>
                                    </div>
                                    {
                                        mainData && mainData?.length > 0 ?
                                            (<div> <ApexStackColumnChart xAxisList={xAxisList} isPNL={true}
                                                colorList={['#f43f5e', '#2fa133']}
                                                dataList={PNLdataList} type={"bar"} width={"100%"} ></ApexStackColumnChart>
                                                <div className="flex justify-center gap-2 items-baseline mb-10">
                                                    <div style={{ padding: "5px", height: "5px", width: "5px", border: "1px solid gray", background: "#f43f5e" }} /> Loss
                                                    <div style={{ padding: "5px", height: "5px", width: "5px", border: "1px solid gray", background: "#2fa133" }} /> Profit
                                                </div>
                                            </div>
                                            )

                                            :
                                            (<div className="text-gray-400  p-7 text-center" >Loading......</div>)
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </MainContainer >
        </div >
    )
}
export default TextileMasterDashboard